import { apiClient, Auth } from '@/shared/api'

import { THostPayDetail } from '../model/schema'

export const getHostPayDetail = async (contractId: number) => {
  const response = await apiClient.get<THostPayDetail>({
    endpoint: `/settlements/${contractId}`,
    auth: Auth.REQUIRED,
  })

  return response
}
